<template>
  <div
    :class="'notify-' + options.position"
    :style="{ width: 'auto' }"
    class="notify"
  >
    <transition-group name="notify" tag="div">
      <div v-for="(item, key) in items" :key="item.id" class="notify-item">
        <div :class="item.options.itemClass">
          <button
            v-if="item.options.closeButtonClass"
            :class="item.options.closeButtonClass"
            type="button"
            aria-label="Close"
            @click="removeItem(key)"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <span v-if="item.options.iconClass" :class="item.options.iconClass" />
          <div v-if="item.options.mode === 'html'" v-html="item.text" />
          <template v-else>{{ item.text }}</template>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  data() {
    return {
      types: {
        info: { itemClass: "alert-info", iconClass: "fa fa-lg fa-info-circle" },
        error: {
          itemClass: "alert-danger",
          iconClass: "fa fa-lg fa-exclamation-triangle"
        },
        warning: {
          itemClass: "alert-warning",
          iconClass: "fa fa-lg fa-exclamation-circle"
        },
        success: {
          itemClass: "alert-success",
          iconClass: "fa fa-lg fa-check-circle"
        }
      },
      options: {
        itemClass: "alert col-12",
        duration: 500,
        visibility: 3000,
        position: "bottom-right",
        enter: "slideDown",
        leave: "slideUp",
        closeButtonClass: false,
        width: "", // "200px",
        mode: "text",
        permanent: false
      },
      items: {},
      idx: 0
    };
  },
  computed: {
    width() {
      if (
        this.options.position === "top-full" ||
        this.options.position === "bottom-full"
      ) {
        return "auto";
      }

      return this.options.width;
    }
  },
  methods: {
    setTypes(types) {
      this.types = types;
    },
    addItem(type, msg, options) {
      const defaultOptions = {
        iconClass: this.types[type].iconClass,
        itemClass: [this.options.itemClass, this.types[type].itemClass],
        visibility: this.options.visibility,
        mode: this.options.mode,
        closeButtonClass: this.options.closeButtonClass,
        permanent: this.options.permanent
      };
      const itemOptions = { ...defaultOptions, ...options };
      // get idx
      const idx = this.idx;

      // add it to the queue (if it's not already there)
      // Vue.set(object, key, value)
      Vue.set(this.items, this.idx, {
        id: idx,
        type,
        text: msg,
        options: itemOptions
      });
      // increment key
      this.idx += 1;
      // remove item if not permanent
      if (itemOptions.permanent === false) {
        // remove item from array
        setTimeout(() => {
          this.removeItem(idx);
        }, this.options.duration + itemOptions.visibility);
      }
    },
    slideDown(el) {
      // remove
    },
    slideUp(el, done) {
      // remove
    },
    removeItem(index) {
      Vue.delete(this.items, index);
    },
    removeAll() {
      this.items = {};
    }
  }
};
</script>

<style>
.notify-top-full {
  position: fixed;
  top: 5px;
  left: 15px;
  right: 15px;
  z-index: 9999;
}
.notify-bottom-full {
  position: fixed;
  bottom: 5px;
  left: 15px;
  right: 15px;
  z-index: 9999;
}
.notify-top-right {
  position: fixed;
  top: 5px;
  right: 15px;
}
.notify-top-left {
  position: fixed;
  top: 5px;
  left: 15px;
}
.notify-bottom-left {
  position: fixed;
  bottom: 5px;
  width: 300px;
  left: 15px;
}
.notify-bottom-right {
  position: fixed;
  bottom: 5px;
  right: 15px;
}
.notify {
  z-index: 100;
}
</style>
